import { footerData, siteInfo } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6">
        <div className="py-12 md:py-16">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
            <div className="flex-1 max-w-sm">
              <a
                href="#hero"
                onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
                className="inline-flex items-center gap-2 mb-4 cursor-pointer"
              >
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-movie-2-line text-xl text-background-50"></i>
                </span>
                <span className="text-lg font-bold text-foreground-950">爱豆影视</span>
              </a>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {footerData.description}
              </p>
            </div>

            <div className="flex flex-wrap gap-8 lg:gap-16">
              <div>
                <h4 className="text-sm font-semibold text-foreground-950 mb-3">剧集分类</h4>
                <ul className="flex flex-col gap-2">
                  {footerData.links.drama.map((link) => (
                    <li key={link.title}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                        className="text-sm text-foreground-600 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                      >
                        {link.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-950 mb-3">平台导航</h4>
                <ul className="flex flex-col gap-2">
                  {footerData.links.platform.map((link) => (
                    <li key={link.title}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                        className="text-sm text-foreground-600 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                      >
                        {link.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-sm font-semibold text-foreground-950 mb-3">热门推荐</h4>
                <ul className="flex flex-col gap-2">
                  {footerData.links.hot.map((link) => (
                    <li key={link.title}>
                      <a
                        href={link.href}
                        onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                        className="text-sm text-foreground-600 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                      >
                        {link.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-200/60">
            <div className="mb-6">
              <h4 className="text-sm font-semibold text-foreground-950 mb-3">合作伙伴</h4>
              <p className="text-xs text-foreground-500">优质内容合作平台持续接入中，敬请期待。</p>
            </div>
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
              </p>
              <p className="text-xs text-foreground-500">
                免责声明：本站内容仅供学习交流，请于下载后24小时内删除。
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}